import { ChangeEvent } from "react"

export const handleString =
  (setter: (v: string) => void) =>
  (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setter(e.currentTarget.value)
  }
